export default __webpack_public_path__ + "assets/models/a092ad75a299048d8f33262c76563616.glb";